/**
 * Centralized Configuration Constants
 * Eliminates magic strings for configuration keys and event names.
 * Aligns with the project's "100% Dynamic" and "No Magic Values" mandates.
 */

export const CONFIG_KEYS = {
    API: 'frontend.api',
    THEME: 'frontend.theme',
    THEME_STORE: 'sp:theme:store',
} as const;

export const CONFIG_EVENTS = {
    UPDATED: 'configuration.updated',
} as const;

export const UPDATE_KEYS = {
    ALL: 'all',
    THEME: 'frontend.theme',
    API: 'frontend.api',
} as const;
